const authorRuleActivities = [
  {
    name: 'loadRuleAuthoringView',
    value: 'LoadRuleAuthoringView',
  },
  {
    name: 'loadExistingRule',
    value: 'LoadExistingRule',
  },
  {
    name: 'previewRuleResults',
    value: 'PreviewRuleResults',
  },
  {
    name: 'onScopeSelectionChange',
    value: 'OnScopeSelectionChange',
  },
  {
    name: 'onCampaignAdGroupSelectionDone',
    value: 'OnCampaignAdGroupSelectionDone',
  },
  {
    name: 'onCampaignAdGroupSelectionCancel',
    value: 'OnCampaignAdGroupSelectionCancel',
  },
  {
    name: 'initCampaignAdGroupSelector',
    value: 'InitCampaignAdGroupSelector',
  },
  {
    name: 'preSelectCampaignAdGroupSelector',
    value: 'PreSelectCampaignAdGroupSelector',
  },
  {
    name: 'createRule',
    value: 'CreateRule',
  },
];

const campaignCreationActivities = [
  {
    name: 'campaignCreationStep1',
    value: 'CampaignCreationStep1',
  },
  {
    name: 'campaignCreationStep2',
    value: 'CampaignCreationStep2',
  },
  {
    name: 'campaignCreationStep3',
    value: 'CampaignCreationStep3',
  },
  {
    name: 'campaignCreationStep4',
    value: 'CampaignCreationStep4',
  },
  {
    name: 'campaignCreationFlowFinished',
    value: 'CampaignCreationFlowFinished',
  },
];

export const schema = {
  scenario: [
    {
      name: 'campaignOverviewEdit',
      value: 'campaignOverviewEdit',
      setting: {},
      activity: [
        {
          name: 'budgetEdit',
          value: 'budgetEdit',
        },
        {
          name: 'bidStrategyEdit',
          value: 'bidStrategyEdit',
        },
        {
          name: 'campaignStatusEdit',
          value: 'campaignStatusEdit',
        },
      ],
    },
    {
      name: 'autobiddingLimitedStatus',
      value: 'AutobiddingLimitedStatus',
      setting: {},
      activity: [
        {
          name: 'renderDeliveryStatus',
          value: 'renderDeliveryStatus',
        },
        {
          name: 'hoverDeliveryStatus',
          value: 'hoverDeliveryStatus',
        },
        {
          name: 'applyDeliveryStatus',
          value: 'ApplyDeliveryStatus',
        },
      ],
    },
    {
      name: 'editorial',
      value: 'Editorial',
      setting: {},
      activity: [
        {
          name: 'toggleCountryList',
          value: 'toggleCountryList',
        },
        {
          name: 'clickRequestException',
          value: 'clickRequestException',
        },
        {
          name: 'submitRequestException',
          value: 'submitRequestException',
        },
      ],
    },
    {
      name: 'datepicker',
      value: 'datepicker',
      setting: {},
      activity: [
        {
          name: 'inlineDateChange',
          value: 'inlineDateChange',
        },
      ],
    },
    {
      name: 'changeTextAd',
      value: 'ChangeTextAd',
      setting: {},
      activity: [
        {
          name: 'changeTextAd',
          value: 'ChangeTextAd',
        },
      ],
    },
    {
      name: 'autoApplyRecdSettingUpdate',
      value: 'autoApplyRecdSettingUpdate',
      setting: {},
      activity: [
        {
          name: 'autoApplyRecdSettingUpdate',
          value: 'autoApplyRecdSettingUpdate',
        },
      ],
    },
    {
      name: 'multiMediaAdsAutoApplyAccountOption',
      value: 'multiMediaAdsAutoApplyAccountOption',
      setting: {},
      activity: [
        {
          name: 'multiMediaAdsAutoApplyAccountOption',
          value: 'multiMediaAdsAutoApplyAccountOption',
        },
      ],
    },
    {
      name: 'responsiveSearchAdsAutoApplyAccountOption',
      value: 'responsiveSearchAdsAutoApplyAccountOption',
      setting: {},
      activity: [
        {
          name: 'responsiveSearchAdsAutoApplyAccountOption',
          value: 'responsiveSearchAdsAutoApplyAccountOption',
        },
      ],
    },
    {
      name: 'enableMMAInDSAAccountOption',
      value: 'enableMMAInDSAAccountOption',
      setting: {},
      activity: [
        {
          name: 'enableMMAInDSAAccountOption',
          value: 'enableMMAInDSAAccountOption',
        },
      ],
    },
    {
      name: 'bulkEditKeywordBid',
      value: 'BulkEditKeywordBid',
      setting: {},
      activity: [
        {
          name: 'bulkEditKeywordBid',
          value: 'BulkEditKeywordBid',
        },
      ],
    },
    {
      name: 'bulkEditKeywordMatchType',
      value: 'BulkEditKeywordMatchType',
      setting: {},
      activity: [
        {
          name: 'bulkEditKeywordMatchType',
          value: 'BulkEditKeywordMatchType',
        },
      ],
    },
    {
      name: 'bulkEditUrlOptionsKeyword',
      value: 'BulkEditUrlOptionsKeyword',
      setting: {},
      activity: [
        {
          name: 'bulkEditUrlOptionsKeyword',
          value: 'BulkEditUrlOptionsKeyword',
        },
      ],
    },
    {
      name: 'bulkEditUrlOptionsCampaign',
      value: 'BulkEditUrlOptionsCampaign',
      setting: {},
      activity: [
        {
          name: 'bulkEditUrlOptionsCampaign',
          value: 'BulkEditUrlOptionsCampaign',
        },
      ],
    },
    {
      name: 'bulkEditUrlOptionsAd',
      value: 'BulkEditUrlOptionsAd',
      setting: {},
      activity: [
        {
          name: 'bulkEditUrlOptionsAd',
          value: 'BulkEditUrlOptionsAd',
        },
      ],
    },
    {
      name: 'bulkEditMMAConversionAd',
      value: 'BulkEditMMAConversionAd',
      setting: {},
      activity: [
        {
          name: 'bulkEditMMAConversionAd',
          value: 'BulkEditMMAConversionAd',
        },
      ],
    },
    {
      name: 'bulkEditUrlOptionsAdGroup',
      value: 'BulkEditUrlOptionsAdGroup',
      setting: {},
      activity: [
        {
          name: 'bulkEditUrlOptionsAdGroup',
          value: 'BulkEditUrlOptionsAdGroup',
        },
      ],
    },
    {
      name: 'bulkEditCampaignExclusions',
      value: 'BulkEditCampaignExclusions',
      setting: {},
      activity: [
        {
          name: 'bulkEditCampaignExclusions',
          value: 'BulkEditCampaignExclusions',
        },
      ],
    },
    {
      name: 'bulkEditCampaignBudget',
      value: 'BulkEditCampaignBudget',
      setting: {},
      activity: [
        {
          name: 'bulkEditCampaignBudget',
          value: 'BulkEditCampaignBudget',
        },
      ],
    },
    {
      name: 'bulkEditCampaignCashbackBudget',
      value: 'BulkEditCampaignCashbackBudget',
      setting: {},
      activity: [
        {
          name: 'bulkEditCampaignCashbackBudget',
          value: 'BulkEditCampaignCashbackBudget',
        },
      ],
    },
    {
      name: 'viewAudiences',
      value: 'ViewAudiences',
      setting: {},
      activity: [
        {
          name: 'loadAudiences',
          value: 'LoadAudiences',
        },
        {
          name: 'loadAudiencesV2',
          value: 'LoadAudiencesV2',
        },
      ],
    },
    {
      name: 'goToUetTagsPageViaLinkInAudiencePage',
      value: 'GoToUetTagsPageViaLinkInAudiencePage',
      setting: {},
      activity: [
        {
          name: 'clickOnPageLink',
          value: 'ClickOnPageLink',
        },
      ],
    },
    {
      name: 'goToAudienceTabViaLinkInAudiencePage',
      value: 'GoToAudienceTabViaLinkInAudiencePage',
      setting: {},
      activity: [
        {
          name: 'clickOnPageLink',
          value: 'ClickOnPageLink',
        },
      ],
    },
    {
      name: 'viewAudiencesAssociations',
      value: 'ViewAudiencesAssociations',
      setting: {},
      activity: [
        {
          name: 'loadAudiences',
          value: 'LoadAudiences',
        },
        {
          name: 'loadAudiencesV2',
          value: 'LoadAudiencesV2',
        },
        {
          name: 'audienceChangeBid',
          value: 'AudienceChangeBid',
        },
        {
          name: 'audienceBidRecommendation',
          value: 'AudienceBidRecommendation',
        },
      ],
    },
    {
      name: 'loadAudienceAssociation',
      value: 'LoadAudienceAssociation',
      setting: {},
      activity: [
        {
          name: 'loadAudienceAssociation',
          value: 'LoadAudienceAssociation',
        },
      ],
    },
    {
      name: 'loadAudienceAssociationByDmp',
      value: 'LoadAudienceAssociationByDmp',
      setting: {},
      activity: [
        {
          name: 'loadAudienceAssociationByDmp',
          value: 'LoadAudienceAssociationByDmp',
        },
      ],
    },
    {
      name: 'inlineUpdateAudienceAssociation',
      value: 'InlineUpdateAudienceAssociation',
      setting: {},
      activity: [
        {
          name: 'inlineUpdateAudienceAssociation',
          value: 'InlineUpdateAudienceAssociation',
        },
      ],
    },
    {
      name: 'loadAudienceAssociationBidAdjustment',
      value: 'LoadAudienceAssociationBidAdjustment',
      setting: {},
      activity: [
        {
          name: 'getBidSuggestion',
          value: 'GetBidSuggestion',
        },
      ],
    },
    {
      name: 'applyAudienceAssociationBidAdjustment',
      value: 'ApplyAudienceAssociationBidAdjustment',
      setting: {},
      activity: [
        {
          name: 'applyManualSetting',
          value: 'ApplyManualSetting',
        },
        {
          name: 'applyBidSuggestion',
          value: 'ApplyBidSuggestion',
        },
      ],
    },
    {
      name: 'loadAudienceNetworkPlanner',
      value: 'LoadAudienceNetworkPlanner',
      setting: {},
      activity: [
        {
          name: 'launch',
          value: 'Launch',
        },
        {
          name: 'chartView',
          value: 'ChartView',
        },
      ],
    },
    {
      name: 'fetchAccountForAudienceNetworkPlanner',
      value: 'fetchAccountForAudienceNetworkPlanner',
      setting: {},
      activity: [
        {
          name: 'fetchAccount',
          value: 'FetchAccount',
        },
      ],
    },
    {
      name: 'audienceBulkEditExclude',
      value: 'AudienceBulkEditExclude',
      setting: {},
      activity: [
        {
          name: 'audienceBulkEditExclude',
          value: 'AudienceBulkEditExclude',
        },
      ],
    },
    {
      name: 'viewDimensionGrid',
      value: 'ViewDimensionGrid',
      setting: {},
      activity: [
        {
          name: 'loadDimensionGrid',
          value: 'LoadDimensionGrid',
        },
        {
          name: 'loadDimensionColumns',
          value: 'LoadDimensionColumns',
        },
        {
          name: 'filterDimensionGrid',
          value: 'FilterDimensionGrid',
        },
      ],
    },
    {
      name: 'pageUnload',
      value: 'PageUnload',
      setting: {},
      activity: [
        {
          name: 'runAriaV2UnloadHandler',
          value: 'RunAriaV2UnloadHandler',
        },
      ],
    },
    {
      name: 'createOrManageAudience',
      value: 'CreateOrManageAudience',
      setting: {},
      activity: [
        {
          name: 'clickOnManageTagLink',
          value: 'ClickOnManageTagLink',
        },
        {
          name: 'loadUETTagsList',
          value: 'LoadUETTagsList',
        },
      ],
    },
    {
      name: 'testUetClarity',
      value: 'TestUetClarity',
      setting: {},
      activity: [
        {
          name: 'createTag',
          value: 'CreateTag',
        },
        {
          name: 'editTag',
          value: 'EditTag',
        },
      ],
    },
    {
      name: 'testConversionGoals',
      value: 'TestConversionGoals',
      setting: {},
      activity: [
        {
          name: 'clickOnGoalBulbIcon',
          value: 'ClickOnGoalBulbIcon',
        },
        {
          name: 'clickOnTestThisGoalFromGoalBulbPopup',
          value: 'ClickOnTestThisGoalFromGoalBulbPopup',
        },
        {
          name: 'clickOnTestThisGoalFromTrackingStatusPopup',
          value: 'ClickOnTestThisGoalFromTrackingStatusPopup',
        },
      ],
    },
    {
      name: 'smartGoalDialogActions',
      value: 'smart goal dialog actions',
      setting: {},
      activity: [
        {
          name: 'setPreference',
          value: 'set preference',
        },
      ],
    },
    {
      name: 'testAudiencesWithConversionAdvisor',
      value: 'TestAudiencesWithConversionAdvisor',
      setting: {},
      activity: [
        {
          name: 'testFromAudienceStatusColumn',
          value: 'TestFromAudienceStatusColumn',
        },
        {
          name: 'testFromUetTrackingStatusColumn',
          value: 'TestFromUetTrackingStatusColumn',
        },
      ],
    },
    {
      name: 'importFromFileSPA',
      value: 'ImportFromFileSPA',
      setting: {},
      activity: [
        {
          name: 'clickOnImportFromFileSPA',
          value: 'ClickOnImportFromFileSPA',
        },
        {
          name: 'renderImportColumnMatching',
          value: 'RenderImportColumnMatching',
        },
        {
          name: 'renderImportOptions',
          value: 'RenderImportOptions',
        },
        {
          name: 'renderImportPreview',
          value: 'RenderImportPreview',
        },
        {
          name: 'renderImportSummary',
          value: 'RenderImportSummary',
        },
      ],
    },
    {
      name: 'importFromGoogleAdWordsSPA',
      value: 'ImportFromGoogleAdWordsSPA',
      setting: {},
      activity: [
        {
          name: 'clickOnImportFromGoogleAdWordsSPA',
          value: 'ClickOnImportFromGoogleAdWordsSPA',
        },
        {
          name: 'renderSelectAdWordsAccount',
          value: 'RenderSelectAdWordsAccount',
        },
        {
          name: 'renderImportOptions',
          value: 'RenderImportOptions',
        },
        {
          name: 'renderSelectAdWordsCampaigns',
          value: 'RenderSelectAdWordsCampaigns',
        },
        {
          name: 'renderImportSummary',
          value: 'RenderImportSummary',
        },
        'requestCallFromSupport', // TO DO
        'startLiveChat', // TO DO

        // log in
        'clickOnSignInButton',
        'logInAccount',

        // choose account
        'accountSelectionSkipped',
        'searchInAccount',
        'accountList',
        'currencyConversionDisplayed',
        'currencyConversionChanged',
        'accountWithoutCampaignSelected',
        'tempSelectedAccount',
        'selectAccount',

        // choose campaign
        'searchInCampaign',
        'campaignSelectionChanged',
        'selectAllCampaigns',
        'showPausedCampaigns',
        'showPausedAdGroups',
        'pageNumberChange',
        'selectCampaign', // include total and selected, all or specific, per type count d

        // options
        'newItemsOptionsClicked', // TO DO
        'existingItemsOptionsClicked', // TO DO
        'bidsAndBudgetsClicked', // TO DO
        'otherOptionsClicked', // TO DO
        'optionChanged',
        'configureOptions',

        // schedule
        'importNameChanged',
        'frequencyChanged',
        'completeSchedule',
      ],
    },
    {
      name: 'importFromAmazonSPA',
      value: 'importFromAmazonSPA',
      setting: {},
      activity: [
        {
          name: 'clickOnImportFromAmazonSPA',
          value: 'clickOnImportFromAmazonSPA',
        },
        {
          name: 'renderSelectAmazonAccount',
          value: 'renderSelectAmazonAccount',
        },
        {
          name: 'renderImportOptions',
          value: 'RenderImportOptions',
        },
        {
          name: 'renderSelectAmazonCampaigns',
          value: 'renderSelectAmazonCampaigns',
        },
        {
          name: 'renderImportSummary',
          value: 'RenderImportSummary',
        },
        'requestCallFromSupport', // TO DO
        'startLiveChat', // TO DO

        // log in
        'clickOnSignInButton',
        'logInAccount',

        // choose account
        'accountSelectionSkipped',
        'searchInAccount',
        'accountList',
        'currencyConversionDisplayed',
        'currencyConversionChanged',
        'accountWithoutCampaignSelected',
        'tempSelectedAccount',
        'selectAccount',

        // choose campaign
        'searchInCampaign',
        'campaignSelectionChanged',
        'selectAllCampaigns',
        'showPausedCampaigns',
        'showPausedAdGroups',
        'pageNumberChange',
        'selectCampaign', // include total and selected, all or specific, per type count d

        // options
        'newItemsOptionsClicked', // TO DO
        'existingItemsOptionsClicked', // TO DO
        'bidsAndBudgetsClicked', // TO DO
        'otherOptionsClicked', // TO DO
        'optionChanged',
        'configureOptions',

        // schedule
        'importNameChanged',
        'frequencyChanged',
        'completeSchedule',
      ],
    },
    {
      name: 'importFromPinterestSPA',
      value: 'importFromPinterestSPA',
      setting: {},
      activity: [
        {
          name: 'clickOnImportFromPinterestSPA',
          value: 'clickOnImportFromPinterestSPA',
        },
      ],
    },
    {
      name: 'importFromFacebookSPA',
      value: 'ImportFromFacebookSPA',
      setting: {},
      activity: [
        {
          name: 'clickOnImportFromFacebookSPA',
          value: 'ClickOnImportFromFacebookSPA',
        },
        {
          name: 'renderSelectAdWordsAccount',
          value: 'RenderSelectAdWordsAccount',
        },
        {
          name: 'renderImportOptions',
          value: 'RenderImportOptions',
        },
        {
          name: 'renderSelectAdWordsCampaigns',
          value: 'RenderSelectAdWordsCampaigns',
        },
        {
          name: 'renderImportSummary',
          value: 'RenderImportSummary',
        },
        'requestCallFromSupport', // TO DO
        'startLiveChat', // TO DO

        // log in
        'clickOnSignInButton',
        'logInAccount',

        // choose account
        'accountSelectionSkipped',
        'searchInAccount',
        'accountList',
        'currencyConversionDisplayed',
        'currencyConversionChanged',
        'accountWithoutCampaignSelected',
        'tempSelectedAccount',
        'selectAccount',

        // choose campaign
        'searchInCampaign',
        'campaignSelectionChanged',
        'selectAllCampaigns',
        'showPausedCampaigns',
        'showPausedAdGroups',
        'pageNumberChange',
        'selectCampaign', // include total and selected, all or specific, per type count d

        // options
        'newItemsOptionsClicked', // TO DO
        'existingItemsOptionsClicked', // TO DO
        'bidsAndBudgetsClicked', // TO DO
        'otherOptionsClicked', // TO DO
        'optionChanged',
        'configureOptions',

        // schedule
        'importNameChanged',
        'frequencyChanged',
        'completeSchedule',
      ],
    },
    {
      name: 'continueImportSPA',
      value: 'ContinueImportSPA',
      setting: {},
      activity: [
        {
          name: 'loadContinueImportSPA',
          value: 'LoadContinueImportSPA',
        },
      ],
    },
    {
      name: 'label',
      value: 'Label',
      setting: {},
      activity: [
        {
          name: 'createLabel',
          value: 'CreateLabel',
        },
      ],
    },
    {
      name: 'adgroupBidlandscape',
      value: 'AdgroupBidlandscape',
      setting: {},
      activity: [
        {
          name: 'fetch',
          value: 'Fetch',
        },
        {
          name: 'apply',
          value: 'Apply',
        },
        {
          name: 'applyBidLandscapeWitoutClearCustomBid',
          value: 'ApplyBidLandscapeWitoutClearCustomBid',
        },
        {
          name: 'applyBidLandscapeAndClearCustomBid',
          value: 'ApplyBidLandscapeAndClearCustomBid',
        },
      ],
    },
    {
      name: 'keywordBidlandscape',
      value: 'KeywordBidlandscape',
      setting: {},
      activity: [
        {
          name: 'fetch',
          value: 'Fetch',
        },
        {
          name: 'apply',
          value: 'Apply',
        },
        {
          name: 'update',
          value: 'Update',
        },
        {
          name: 'close',
          value: 'Close',
        },
      ],
    },
    {
      name: 'logDeliveryStatus',
      value: 'LogDeliveryStatus',
      setting: {},
      activity: [
        {
          name: 'logAdsDeliveryStatus',
          value: 'LogAdsDeliveryStatus',
        },
        {
          name: 'logKeywordsDeliveryStatus',
          value: 'LogKeywordsDeliveryStatus',
        },
      ],
    },
    {
      name: 'authorRuleKeyword',
      value: 'AuthorRuleKeyword',
      setting: {},
      activity: authorRuleActivities,
    },
    {
      name: 'authorRuleAd',
      value: 'AuthorRuleAd',
      setting: {},
      activity: authorRuleActivities,
    },
    {
      name: 'authorRuleAdGroup',
      value: 'AuthorRuleAdGroup',
      setting: {},
      activity: authorRuleActivities,
    },
    {
      name: 'authorRuleCampaign',
      value: 'AuthorRuleCampaign',
      setting: {},
      activity: authorRuleActivities,
    },
    {
      name: 'authorRuleAssetGroup',
      value: 'AuthorRuleAssetGroup',
      setting: {},
      activity: authorRuleActivities,
    },
    {
      name: 'searchAdGroupCreation',
      value: 'SearchAdGroupCreation',
      setting: {},
      activity: [
        {
          name: 'adGroupCreation',
          value: 'AdGroupCreation',
        },
      ],
    },
    {
      name: 'shoppingAdGroupCreation',
      value: 'shoppingAdGroupCreation',
      setting: {},
      activity: [
        {
          name: 'adGroupCreation',
          value: 'AdGroupCreation',
        },
      ],
    },
    {
      name: 'dynamicSearchAdGroupCreation',
      value: 'DynamicSearchAdGroupCreation',
      setting: {},
      activity: [
        {
          name: 'adGroupCreation',
          value: 'AdGroupCreation',
        },
      ],
    },
    {
      name: 'searchAdGroupSettings',
      value: 'SearchAdGroupSettings',
      setting: {},
      activity: [
        {
          name: 'adGroupSettings',
          value: 'AdGroupSettings',
        },
      ],
    },
    {
      name: 'shoppingAdGroupSettings',
      value: 'ShoppingAdGroupSettings',
      setting: {},
      activity: [
        {
          name: 'adGroupSettings',
          value: 'AdGroupSettings',
        },
      ],
    },
    {
      name: 'dynamicSearchAdGroupSettings',
      value: 'DynamicSearchAdGroupSettings',
      setting: {},
      activity: [
        {
          name: 'adGroupSettings',
          value: 'AdGroupSettings',
        },
      ],
    },
    {
      name: 'audienceAdGroupSettings',
      value: 'AudienceAdGroupSettings',
      setting: {},
      activity: [
        {
          name: 'adGroupSettings',
          value: 'AdGroupSettings',
        },
      ],
    },
    {
      name: 'searchCampaignCreation',
      value: 'SearchCampaignCreation',
      setting: {},
      activity: campaignCreationActivities,
    },
    {
      name: 'dynamicSearchCampaignCreation',
      value: 'DynamicSearchCampaignCreation',
      setting: {},
      activity: campaignCreationActivities,
    },
    {
      name: 'signUpCampaignCreation',
      value: 'SignUpCampaignCreation',
      setting: {},
      activity: [
        {
          name: 'signUpCampaignCreation',
          value: 'SignUpCampaignCreation',
        },
        {
          name: 'duration',
          value: 'Duration',
        },
      ],
    },
    {
      name: 'shoppingCampaignCreation',
      value: 'ShoppingCampaignCreation',
      setting: {},
      activity: [
        {
          name: 'shoppingCampaignCreation',
          value: 'ShoppingCampaignCreation',
        },
        {
          name: 'duration',
          value: 'Duration',
        },
      ],
    },
    {
      name: 'searchCampaignEdit',
      value: 'SearchCampaignEdit',
      setting: {},
      activity: [
        {
          name: 'searchCampaignEdit',
          value: 'SearchCampaignEdit',
        },
      ],
    },
    {
      name: 'dynamicSearchCampaignEdit',
      value: 'DynamicSearchCampaignEdit',
      setting: {},
      activity: [
        {
          name: 'dynamicSearchCampaignEdit',
          value: 'DynamicSearchCampaignEdit',
        },
      ],
    },
    {
      name: 'shoppingCampaignEdit',
      value: 'ShoppingCampaignEdit',
      setting: {},
      activity: [
        {
          name: 'shoppingCampaignEdit',
          value: 'ShoppingCampaignEdit',
        },
      ],
    },
    {
      name: 'audienceCampaignEdit',
      value: 'AudienceCampaignEdit',
      setting: {},
      activity: [
        {
          name: 'audienceCampaignEdit',
          value: 'AudienceCampaignEdit',
        },
      ],
    },
    {
      name: 'oldUISmartShoppingCampaignCreationScenario',
      value: 'oldUISmartShoppingCampaignCreationScenario',
      setting: {},
      activity: [
        {
          name: 'SSCCreationActivity',
          value: 'SSCCreationActivity',
        },
      ],
    },
    {
      name: 'newUISmartShoppingCampaignCreationScenario',
      value: 'newUISmartShoppingCampaignCreationScenario',
      setting: {},
      activity: [
        {
          name: 'SSCCreationActivity',
          value: 'SSCCreationActivity',
        },
      ],
    },
    {
      name: 'adCreationExpandedText',
      value: 'AdCreationExpandedText',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adCreationText',
      value: 'AdCreationText',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adCreationDynamicSearch',
      value: 'AdCreationDynamicSearch',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adCreationAppInstall',
      value: 'AdCreationAppInstall',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adCreationProduct',
      value: 'AdCreationProduct',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adCreationResponsive',
      value: 'AdCreationResponsive',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adCreationResponsiveSearch',
      value: 'AdCreationResponsiveSearch',
      setting: {},
      activity: [
        {
          name: 'adCreation',
          value: 'AdCreation',
        },
      ],
    },
    {
      name: 'adEditExpandedText',
      value: 'AdEditExpandedText',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'adEditText',
      value: 'AdEditText',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'adEditDynamicSearch',
      value: 'AdEditDynamicSearch',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'adEditAppInstall',
      value: 'AdEditAppInstall',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'adEditProduct',
      value: 'AdEditProduct',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'adEditResponsive',
      value: 'AdEditResponsive',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'adEditResponsiveSearch',
      value: 'AdEditResponsiveSearch',
      setting: {},
      activity: [
        {
          name: 'adEdit',
          value: 'AdEdit',
        },
      ],
    },
    {
      name: 'imageAdExtension',
      value: 'Image Ad Extension',
      setting: {},
      activity: [
        {
          name: 'cropImage',
          value: 'Crop Image',
        },
      ],
    },
    {
      name: 'leadFormAssociationEditorScenario',
      value: 'leadFormAssociationEditorScenario',
      setting: {},
      activity: [
        {
          name: 'leadFormAssociationEditorActivity',
          value: 'leadFormAssociationEditorActivity',
        },
      ],
    },
    {
      name: 'businessInfoAssociationEditorScenario',
      value: 'businessInfoAssociationEditorScenario',
      setting: {},
      activity: [
        {
          name: 'businessInfoAssociationEditorActivity',
          value: 'businessInfoAssociationEditorActivity',
        },
      ],
    },
    {
      name: 'segmentMenu',
      value: 'SegmentMenu',
      setting: {},
      activity: [
        {
          name: 'segmentMenu',
          value: 'SegmentMenu',
        },
      ],
    },
    {
      name: 'fluctuation',
      value: 'Fluctuation',
      setting: {},
      activity: [
        {
          name: 'fluctuationInstr',
          value: 'FluctuationInstr',
        },
        {
          name: 'fluctuationFeedback',
          value: 'FluctuationFeedback',
        },
        {
          name: 'fluctuationDismiss',
          value: 'FluctuationDismiss',
        },
      ],
    },
    {
      name: 'notificationTab',
      value: 'NotificationTab',
      setting: {},
      activity: [
        {
          name: 'bulkdismiss',
          value: 'Bulkdismiss',
        },
      ],
    },
    {
      name: 'showInlineKeywordDiagnosisPanel',
      value: 'ShowInlineKeywordDiagnosisPanel',
      settings: {},
      activity: [
        {
          name: 'clickOnKeywordPlanner',
          value: 'ClickOnKeywordPlanner',
        },
        {
          name: 'clickOnADTLink',
          value: 'ClickOnADTLink',
        },
      ],
    },
    {
      name: 'chooseNewCampaignObjective',
      value: 'ChooseNewCampaignObjective',
      setting: {},
      activity: [
        {
          name: 'chooseObjective',
          value: 'ChooseObjective',
        },
        {
          name: 'chooseTool',
          value: 'ChooseTool',
        },
        {
          name: 'objectivePage',
          value: 'ObjectivePage',
        },
      ],
    },
    {
      name: 'adsGrid',
      value: 'Ads Grid',
      activity: [
        {
          name: 'fetchRejectionReason',
          value: 'Fetch Rejection Reason',
        },
      ],
    },
    {
      name: 'productGroupGrid',
      value: 'ProductGroupGrid',
      setting: {},
      activity: [
        {
          name: 'recordBidChange',
          value: 'RecordBidChange',
        },
        {
          name: 'recordBidChangeInLandScape',
          value: 'RecordBidChangeInLandScape',
        },
        {
          name: 'recordFetchLandScapeData',
          value: 'RecordFetchLandScapeData',
        },
        {
          name: 'toggleGrid',
          value: 'ToggleGrid',
        },
        {
          name: 'applyFilter',
          value: 'ApplyFilter',
        },
        {
          name: 'changeSelectedColumns',
          value: 'ChangeSelectedColumns',
        },
      ],
    },
    {
      name: 'suggestionInCreationWorkflow',
      value: 'SuggestionInCreationWorkflow',
      setting: {},
      activity: [
        {
          name: 'campaignCreation',
          value: 'CampaignCreation',
        },
        {
          name: 'adGroupCreation',
          value: 'AdGroupCreation',
        },
        {
          name: 'keywordCreation',
          value: 'KeywordCreation',
        },
      ],
    },
    {
      name: 'productsTab',
      value: 'ProductsTab',
      setting: {},
      activity: [
        {
          name: 'gridView',
          value: 'GridView',
        },
      ],
    },
    {
      name: 'campaignTab',
      value: 'CampaignTab',
      setting: {},
      activity: [
        {
          name: 'budgetLandscape',
          value: 'BudgetLandscape',
        },
      ],
    },
    {
      name: 'inlineBudgetEditor',
      value: 'InlineBudgetEditor',
      setting: {},
      activity: [
        {
          name: 'recordBudgetLandscape',
          value: 'RecordBudgetLandscape',
        },
      ],
    },
    {
      name: 'mainlineGrid',
      value: 'MainlineGrid',
      setting: {},
      activity: [
        {
          name: 'entityViewUpdate',
          value: 'EntityViewUpdate',
        },
      ],
    },
    {
      name: 'newUIProductGroupsPageScenario',
      value: 'newUIProductGroupsPageScenario',
      activity: [
        'PGGActivity',
      ],
    },
    {
      name: 'inContextRepairRecommendation',
      value: 'InContextRepairRecommendation',
      activity: [
        {
          name: 'clickDeliveryStatus',
          value: 'ClickDeliveryStatus',
        },
        {
          name: 'hoverDeliveryStatus',
          value: 'HoverDeliveryStatus',
        },
        {
          name: 'applyDeliveryStatus',
          value: 'ApplyDeliveryStatus',
        },
      ],
    },
    {
      name: 'loadFixAdContentOpportunity',
      value: 'LoadFixAdContentOpportunity',
      activity: [
        {
          name: 'apply',
          value: 'Apply',
        },
      ],
    },
    {
      name: 'loadBingMapScenario',
      value: 'loadBingMapScenario',
      activity: [
        {
          name: 'loadBingMapError',
          value: 'loadBingMapError',
        },
      ],
    },
    {
      name: 'hotelCampaignCreation',
      value: 'HotelCampaignCreation',
      setting: {},
      activity: [
        {
          name: 'hotelCampaignCreation',
          value: 'HotelCampaignCreation',
        },
        {
          name: 'duration',
          value: 'Duration',
        },
      ],
    },
    {
      name: 'hotelCampaignSettings',
      value: 'HotelCampaignSettings',
      setting: {},
      activity: [
        {
          name: 'hotelCampaignSettings',
          value: 'HotelCampaignSettings',
        },
        {
          name: 'duration',
          value: 'Duration',
        },
      ],
    },
    {
      name: 'hotelAdGroupCreation',
      value: 'HotelAdGroupCreation',
      setting: {},
      activity: [
        {
          name: 'hotelAdGroupCreation',
          value: 'HotelAdGroupCreation',
        },
        {
          name: 'duration',
          value: 'Duration',
        },
      ],
    },
    {
      name: 'hotelAdGroupSettings',
      value: 'HotelAdGroupSettings',
      setting: {},
      activity: [
        {
          name: 'hotelAdGroupSettings',
          value: 'HotelAdGroupSettings',
        },
        {
          name: 'duration',
          value: 'Duration',
        },
      ],
    },
    {
      name: 'popupManagement',
      value: 'PopupManagement',
      setting: {},
      activity: [
        {
          name: 'popupManager',
          value: 'popupManager',
        },
        {
          name: 'multiStepTeachingBubble',
          value: 'multiStepTeachingBubble',
        },
        {
          name: 'hoverPopupCalloutDuration',
          value: 'HoverPopupCalloutDuration',
        },
      ],
    },
    {
      name: 'notificationTopBanner',
      value: 'notificationTopBanner',
      setting: {},
      activity: [
        {
          name: 'actionLink',
          value: 'actionLink',
        },
      ],
    },
  ],
};
